export default () => {
    function initCards() {
        const cards = document.querySelectorAll('.flip-card-container')

        cards.forEach(card => {
            card.addEventListener('click', (event) => {
                const {target} = event
                const isLogo = target.closest('.lots__link')

                !isLogo ? card.classList.toggle('active') : false
            })
        })
    }

    initCards()
};
